import type { Poll } from 'schema/poll';
import type { ICState, TrackingState } from 'schema/state';
import { pushToStack } from '../../utils';

export interface TrackActionParams {
  trackingState: TrackingState;
  tracking: Required<TrackingState>['tracking'];
}

export function track(_: Poll, prevState: ICState, { trackingState, tracking }: TrackActionParams) {
  for (const track of tracking) {
    const existingIndex = trackingState.tracking.findIndex(it => it.id === track.id);
    if (existingIndex !== -1) trackingState.tracking[existingIndex] = track;
    else trackingState.tracking.push(track);
  }

  /** Обноваляем/Добавляем trackingState в trackingStack */
  const trackingStack = pushToStack(prevState.trackingStack, trackingState, 'id');

  return { ...prevState, trackingStack };
}
